import { type TypedDocumentNode, gql } from '@apollo/client';

import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { CornerBadge, Position } from '@sorare/core/src/components/CornerBadge';

import type { TaskCampaignLabel_taskCampaign } from './__generated__/index.graphql';

type Props = {
  taskCampaign: TaskCampaignLabel_taskCampaign;
};
export const TaskCampaignLabel = ({ taskCampaign }: Props) => {
  const {
    color1 = 'var(--c-nd-600)',
    color2 = 'var(--c-nd-400)',
    tagLabel,
    tagIconUrl,
  } = taskCampaign;

  return (
    <CornerBadge
      color={`linear-gradient(323deg, ${color1} 14.3%, ${color2} 85.7%)`}
      align={Position.LEFT}
    >
      <img height={10} src={tagIconUrl} alt={tagLabel} />
      <BrandXXS color="var(--c-black)">{tagLabel}</BrandXXS>
    </CornerBadge>
  );
};
TaskCampaignLabel.fragments = {
  taskCampaign: gql`
    fragment TaskCampaignLabel_taskCampaign on TaskCampaign {
      slug
      color1: color(variant: PRIMARY)
      color2: color(variant: SECONDARY)
      name
      tagIconUrl
      tagLabel
    }
  ` as TypedDocumentNode<TaskCampaignLabel_taskCampaign>,
};
